export enum RowSelection {
  Button = 'button',
  Item = 'item',
  None = 'none',
}

export const CATEGORIES = [
  { display: 'All results', value: 'All' },
  { display: 'Companies', value: 'Companies' },
  { display: 'Article titles', value: 'Titles' },
  { display: 'Topics', value: 'Topics' },
];
